export const RESET_CONTACT_REQUEST_BANK = 'ContactRequestBank/RESET_CONTACT_REQUEST_BANK';

export const GET_REQUEST_DETAIL = 'ContactRequestBank/GET_REQUEST_DETAIL';
export const GET_REQUEST_DETAIL_SET_DATA = 'ContactRequestBank/GET_REQUEST_DETAIL_SET_DATA';

export const UPDATE_BANK_DETAIL = 'ContactRequestBank/UPDATE_BANK_DETAIL';
export const UPDATE_BANK_DETAIL_SET_DATA = 'ContactRequestBank/UPDATE_BANK_DETAIL_SET_DATA';
